import { render } from "./RegistroLecheAcopio.vue?vue&type=template&id=66d5bc74"
import script from "./RegistroLecheAcopio.vue?vue&type=script&lang=js"
export * from "./RegistroLecheAcopio.vue?vue&type=script&lang=js"

import "./RegistroLecheAcopio.vue?vue&type=style&index=0&id=66d5bc74&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoTransportistas/RegistroLecheAcopio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66d5bc74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66d5bc74', __exports__)) {
    api.reload('66d5bc74', __exports__)
  }
  
  module.hot.accept("./RegistroLecheAcopio.vue?vue&type=template&id=66d5bc74", () => {
    api.rerender('66d5bc74', render)
  })

}


export default __exports__